"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formulaFieldText = exports.rollupFieldText = exports.ipAddressFieldText = exports.tagsFieldText = exports.checklistFieldText = exports.colorPickerFieldText = exports.socialNetworkFieldText = exports.timeTrackingLogFieldText = exports.createUpdateFieldText = exports.buttonFieldText = exports.nesetTextFieldText = exports.availabilityStatusFieldText = exports.voteFieldText = exports.dateRangeFieldText = exports.durationFieldText = exports.timeFieldText = exports.subitemsFieldText = exports.assignedToFieldText = exports.linkedRecordFieldText = exports.countFieldText = exports.recordTitleFieldText = exports.recordText = exports.smartDocFieldText = exports.fileFieldText = exports.linkFieldText = exports.signatureFieldText = exports.addressFieldText = exports.phoneFieldText = exports.emailFieldText = exports.dueDateFieldText = exports.fullNameFieldText = exports.statusFieldText = exports.dateFieldText = exports.multipleSelectFieldText = exports.singleSelectFieldText = exports.dateText = exports.yesNoFieldText = exports.autoNumberFieldText = exports.recordIdFieldText = exports.ratingFieldText = exports.commentsCountFieldText = exports.currencyFieldText = exports.percentFieldText = exports.percentCompleteFieldText = exports.numberSliderFieldText = exports.numberFieldText = exports.validationText = exports.textAreaText = exports.textFieldsText = exports.aggregatesText = void 0;
exports.defaultDateDiffNamesText = exports.dateFormatDistanceText = exports.dependencyFieldText = exports.lookupFieldText = void 0;
const intl_1 = require("@formatjs/intl");
exports.aggregatesText = (0, intl_1.defineMessages)({
    empty: {
        defaultMessage: "Empty",
        id: "+RhnH+",
    },
    non_empty: {
        defaultMessage: "Filled",
        id: "yrzvie",
    },
    percent_filled: {
        defaultMessage: "Percent Filled",
        id: "mi+HJS",
    },
    percent_empty: {
        defaultMessage: "Percent Empty",
        id: "Fl176H",
    },
    sum: {
        defaultMessage: "Sum",
        id: "YYkniy",
    },
    lowest: {
        defaultMessage: "Lowest",
        id: "hDlB8r",
    },
    highest: {
        defaultMessage: "Highest",
        id: "N2oTu1",
    },
    average: {
        defaultMessage: "Average",
        id: "FnRTEV",
    },
    median: {
        defaultMessage: "Median",
        id: "WrSL3+",
    },
    standard_deviation: {
        defaultMessage: "Standard Deviation",
        id: "LPp8ad",
    },
    range: {
        defaultMessage: "Range",
        id: "vhQqLj",
    },
    earliest_date: {
        defaultMessage: "Earliest Date",
        id: "2ABKNV",
    },
    latest_date: {
        defaultMessage: "Latest Date",
        id: "LSkeG+",
    },
    date_range: {
        defaultMessage: "Date Range",
        id: "52QtMe",
    },
    total_number_of_attachments: {
        defaultMessage: "Total Number of Attachments",
        id: "z6n/TT",
    },
    total_attachment_size: {
        defaultMessage: "Total Attachment Size",
        id: "iVLJ40",
    },
});
exports.textFieldsText = (0, intl_1.defineMessages)({
    text: {
        defaultMessage: "Text",
        id: "aA8bDw",
    },
    enter_text_here: {
        defaultMessage: "Enter text here...",
        id: "+lyEkd",
    },
    string: {
        defaultMessage: "string",
        id: "J1fLPK",
    },
    line: {
        defaultMessage: "line",
        id: "4cpx8T",
    },
    is_required: {
        defaultMessage: "{fieldLabel} is required",
        id: "Xbm3iA",
    },
    value_should_be_unique: {
        defaultMessage: "{fieldLabel} value should be unique",
        id: "rCPUBF",
    },
    maximum_characters_allowed: {
        defaultMessage: "The maximum characters allowed has been exceeded",
        id: "ChvdI3",
    },
    enter_a_valid_email_address: {
        defaultMessage: "Enter a valid email address",
        id: "YRe93Y",
    },
});
exports.textAreaText = (0, intl_1.defineMessages)({
    textarea: {
        defaultMessage: "Text Area",
        id: "tsJIB6",
    },
    type_something_here: {
        defaultMessage: "Type something here...",
        id: "p+fgmb",
    },
    string: {
        defaultMessage: "string",
        id: "J1fLPK",
    },
    document: {
        defaultMessage: "document",
        id: "fVrLDp",
    },
    paragraph: {
        defaultMessage: "paragraph",
        id: "d0gwNl",
    },
});
exports.validationText = (0, intl_1.defineMessages)({
    value_is_required: {
        defaultMessage: "Value is required",
        id: "uvmzLk",
    },
    please_enter_correct_number: {
        defaultMessage: "Please enter correct number",
        id: "FsTUql",
    },
    value_must_be_between: {
        defaultMessage: "Value must be between {minValue} and {maxValue}",
        id: "kS9EPW",
    },
    phone_number: {
        defaultMessage: "Enter a valid phone number.",
        id: "3q+czG",
    },
});
exports.numberFieldText = (0, intl_1.defineMessages)({
    number: {
        defaultMessage: "Number",
        id: "kFkPWB",
    },
    enter_number_here: {
        defaultMessage: "Enter number here...",
        id: "zcIUvf",
    },
    integer: {
        defaultMessage: "integer",
        id: "twEEi6",
    },
    decimal: {
        defaultMessage: "decimal",
        id: "I6QLJK",
    },
});
exports.numberSliderFieldText = (0, intl_1.defineMessages)({
    number_slider: {
        defaultMessage: "Number Slider",
        id: "9HiNmV",
    },
    enter_number_here: {
        defaultMessage: "Enter number here...",
        id: "zcIUvf",
    },
    progress: {
        defaultMessage: "progress",
        id: "G+2vog",
    },
    done: {
        defaultMessage: "done",
        id: "B7ijKz",
    },
});
exports.percentCompleteFieldText = (0, intl_1.defineMessages)({
    percent_complete: {
        defaultMessage: "Percent Complete",
        id: "EQ8mDT",
    },
    enter_number_here: {
        defaultMessage: "Enter number here...",
        id: "zcIUvf",
    },
    progress: {
        defaultMessage: "progress",
        id: "G+2vog",
    },
    done: {
        defaultMessage: "done",
        id: "B7ijKz",
    },
});
exports.percentFieldText = (0, intl_1.defineMessages)({
    percent: {
        defaultMessage: "Percent",
        id: "DqKd4r",
    },
    enter_number_here: {
        defaultMessage: "Enter number here...",
        id: "zcIUvf",
    },
});
exports.currencyFieldText = (0, intl_1.defineMessages)({
    currency: {
        defaultMessage: "Currency",
        id: "55hdQy",
    },
    enter_number_here: {
        defaultMessage: "Enter number here...",
        id: "zcIUvf",
    },
    money: {
        defaultMessage: "money",
        id: "iXf76r",
    },
});
exports.commentsCountFieldText = (0, intl_1.defineMessages)({
    open_comments: {
        defaultMessage: "Open comments",
        id: "TqM06y",
    },
    enter_number_here: {
        defaultMessage: "Enter number here...",
        id: "zcIUvf",
    },
    this_is_a_system_field: {
        defaultMessage: "This is a system field and it cannot be duplicated.",
        id: "dwGnRu",
    },
});
exports.ratingFieldText = (0, intl_1.defineMessages)({
    rating: {
        defaultMessage: "Rating",
        id: "ETRyBL",
    },
    enter_number_here: {
        defaultMessage: "Enter number here...",
        id: "zcIUvf",
    },
    score: {
        defaultMessage: "score",
        id: "hBOujq",
    },
    nps: {
        defaultMessage: "nps",
        id: "f5Ka8X",
    },
});
exports.recordIdFieldText = (0, intl_1.defineMessages)({
    record_id: {
        defaultMessage: "Record ID",
        id: "4ucbkf",
    },
    enter_number_here: {
        defaultMessage: "Enter number here...",
        id: "zcIUvf",
    },
    guid: {
        defaultMessage: "guid",
        id: "Cz6qWn",
    },
    unique: {
        defaultMessage: "unique",
        id: "Cn03Wb",
    },
});
exports.autoNumberFieldText = (0, intl_1.defineMessages)({
    auto_number: {
        defaultMessage: "Auto Number",
        id: "7f4a7V",
    },
    enter_number_here: {
        defaultMessage: "Enter number here...",
        id: "zcIUvf",
    },
    increment: {
        defaultMessage: "increment",
        id: "gEC13g",
    },
    this_is_a_system_field: {
        defaultMessage: "This is a system field and it cannot be duplicated.",
        id: "dwGnRu",
    },
});
exports.yesNoFieldText = (0, intl_1.defineMessages)({
    yes: {
        defaultMessage: "Yes",
        id: "a5msuh",
    },
    true: {
        defaultMessage: "True",
        id: "KKkUks",
    },
    y: {
        defaultMessage: "Y",
        id: "SSHeHt",
    },
    on: {
        defaultMessage: "On",
        id: "Zh+5A6",
    },
    selected: {
        defaultMessage: "Selected",
        id: "byP6IC",
    },
    no: {
        defaultMessage: "No",
        id: "oUWADl",
    },
    false: {
        defaultMessage: "False",
        id: "rxqs5U",
    },
    n: {
        defaultMessage: "N",
        id: "azsAaq",
    },
    off: {
        defaultMessage: "Off",
        id: "OvzONl",
    },
    yes_no: {
        defaultMessage: "Yes / No",
        id: "aNY6/x",
    },
    select_yes_or_no: {
        defaultMessage: "Select Yes or No...",
        id: "eupRwd",
    },
    not: {
        defaultMessage: "Not",
        id: "7he3DM",
    },
});
exports.dateText = (0, intl_1.defineMessages)({
    date: {
        defaultMessage: "Date",
        id: "P7PLVj",
    },
    date_at_time: {
        defaultMessage: "{formattedDate} at {formattedTime}",
        id: "pm9lwy",
    },
    date_at_time_export: {
        defaultMessage: '{formattedDate} "at" {formattedTime}',
        id: "L1vth3",
    },
});
exports.singleSelectFieldText = (0, intl_1.defineMessages)({
    single_select: {
        defaultMessage: "Single Select",
        id: "9PRl15",
    },
    type_or_select_value: {
        defaultMessage: "Type or select value",
        id: "w84sq3",
    },
    list: {
        defaultMessage: "list",
        id: "51usok",
    },
});
exports.multipleSelectFieldText = (0, intl_1.defineMessages)({
    multiple_select: {
        defaultMessage: "Multiple Select",
        id: "TzATGX",
    },
    select_from_list: {
        defaultMessage: "Select from list...",
        id: "zrZNIF",
    },
    list: {
        defaultMessage: "list",
        id: "51usok",
    },
});
exports.dateFieldText = (0, intl_1.defineMessages)({
    enter_date_here: {
        defaultMessage: "Enter date here...",
        id: "IPkscP",
    },
});
exports.statusFieldText = (0, intl_1.defineMessages)({
    status: {
        defaultMessage: "Status",
        id: "tzMNF3",
    },
    select_status: {
        defaultMessage: "Select Status",
        id: "Wp9sv1",
    },
});
exports.fullNameFieldText = (0, intl_1.defineMessages)({
    full_name: {
        defaultMessage: "Full Name",
        id: "TemVby",
    },
    enter_full_name: {
        defaultMessage: "Enter full name here...",
        id: "53gyVy",
    },
    contact: {
        defaultMessage: "contact",
        id: "h1k+6t",
    },
    first: {
        defaultMessage: "first",
        id: "f92A29",
    },
    last: {
        defaultMessage: "last",
        id: "mPCn9j",
    },
});
exports.dueDateFieldText = (0, intl_1.defineMessages)({
    due_date: {
        defaultMessage: "Due Date",
        id: "8XUukm",
    },
    due_date_description: {
        defaultMessage: "Visually track and manage due dates.",
        id: "JEdmhf",
    },
    status_error: {
        defaultMessage: "A Status field is required, and there are no Status fields in the application.",
        id: "jkX4Dm",
    },
    complete: {
        defaultMessage: "Complete",
        id: "U78NhE",
    },
    overdue: {
        defaultMessage: "Overdue",
        id: "M0vCGv",
    },
    in_progress: {
        defaultMessage: "In process",
        id: "U1VM7O",
    },
    type_number_of_days: {
        defaultMessage: "Type Number of Days",
        id: "MwoS2O",
    },
});
exports.emailFieldText = (0, intl_1.defineMessages)({
    email: {
        defaultMessage: "Email",
        id: "sy+pv5",
    },
    enter_an_email_address: {
        defaultMessage: "Enter an email address...",
        id: "U9rnc4",
    },
});
exports.phoneFieldText = (0, intl_1.defineMessages)({
    phone: {
        defaultMessage: "Phone",
        id: "O95R3Z",
    },
    field_description: {
        defaultMessage: "Add one or more formatted phone numbers.",
        id: "K/pzT0",
    },
    enter_phone_here: {
        defaultMessage: "Enter phone here...",
        id: "zBhnab",
    },
    telephone: {
        defaultMessage: "telephone",
        id: "7ZiMiJ",
    },
    cell: {
        defaultMessage: "cell",
        id: "a39+Ww",
    },
    mobile_lower: {
        defaultMessage: "mobile",
        id: "7c3n8r",
    },
    office: {
        defaultMessage: "Office",
        id: "+4MjlG",
    },
    mobile: {
        defaultMessage: "Mobile",
        id: "GWtmtu",
    },
    home: {
        defaultMessage: "Home",
        id: "ejEGdx",
    },
    fax: {
        defaultMessage: "Fax",
        id: "etKfZA",
    },
    other: {
        defaultMessage: "Other",
        id: "/VnDMl",
    },
});
exports.addressFieldText = (0, intl_1.defineMessages)({
    default_address: {
        defaultMessage: "100 Main Street, Suite 300, Los Angeles, California, 90017, United States",
        id: "LyrIaU",
    },
    address: {
        defaultMessage: "Address",
        id: "e6Ph5+",
    },
    type_an_address: {
        defaultMessage: "Type an address...",
        id: "3SFMqt",
    },
    location: {
        defaultMessage: "location",
        id: "PiqxYx",
    },
    street: {
        defaultMessage: "street",
        id: "XAbyxV",
    },
    city: {
        defaultMessage: "city",
        id: "Wfh9EC",
    },
    country: {
        defaultMessage: "country",
        id: "OUDdOB",
    },
    map: {
        defaultMessage: "map",
        id: "Hjyu6/",
    },
});
exports.signatureFieldText = (0, intl_1.defineMessages)({
    signature: {
        defaultMessage: "Signature",
        id: "nQkv1D",
    },
    signed: {
        defaultMessage: "Signed",
        id: "oW2jG6",
    },
    unsigned: {
        defaultMessage: "Unsigned",
        id: "CzE94c",
    },
});
exports.linkFieldText = (0, intl_1.defineMessages)({
    link: {
        defaultMessage: "Link",
        id: "JBWS0c",
    },
    enter_a_website_address: {
        defaultMessage: "Enter a website address...",
        id: "F/zJUV",
    },
    enter_a_valid_url_address: {
        defaultMessage: "Enter a valid URL address",
        id: "iIyDDb",
    },
});
exports.fileFieldText = (0, intl_1.defineMessages)({
    files_and_images: {
        defaultMessage: "Files and Images",
        id: "Ji0LGQ",
    },
    find_a_value: {
        defaultMessage: "Find a value",
        id: "fouoj8",
    },
    upload: {
        defaultMessage: "upload",
        id: "G4ezCI",
    },
    attachment: {
        defaultMessage: "attachment",
        id: "LrLqkd",
    },
    enter_text_here: {
        defaultMessage: "Enter text here...",
        id: "+lyEkd",
    },
    select_type: {
        defaultMessage: "Select type",
        id: "MxhVX1",
    },
    download_all_files: {
        defaultMessage: "Download All Files",
        id: "zOPnC5",
    },
});
exports.smartDocFieldText = (0, intl_1.defineMessages)({
    smartdoc: {
        defaultMessage: "SmartDoc",
        id: "Tu6gDM",
    },
    type_something_here: {
        defaultMessage: "Type something here...",
        id: "p+fgmb",
    },
    string: {
        defaultMessage: "string",
        id: "J1fLPK",
    },
    document: {
        defaultMessage: "document",
        id: "fVrLDp",
    },
    paragraph: {
        defaultMessage: "paragraph",
        id: "d0gwNl",
    },
    rich_text: {
        defaultMessage: "rich text",
        id: "6eFHLA",
    },
    markup: {
        defaultMessage: "markup",
        id: "yTviZ5",
    },
});
exports.recordText = (0, intl_1.defineMessages)({
    untitled_record: {
        defaultMessage: "Untitled Record",
        id: "3g3HnP",
    },
});
exports.recordTitleFieldText = (0, intl_1.defineMessages)({
    record_title: {
        defaultMessage: "Record Title",
        id: "qq5ntX",
    },
    enter_text_here: {
        defaultMessage: "Enter text here...",
        id: "+lyEkd",
    },
    string: {
        defaultMessage: "string",
        id: "J1fLPK",
    },
    line: {
        defaultMessage: "line",
        id: "4cpx8T",
    },
    this_is_a_system_field: {
        defaultMessage: "This is a system field and it cannot be duplicated.",
        id: "dwGnRu",
    },
    untitled_record: {
        defaultMessage: "Untitled Record",
        id: "3g3HnP",
    },
});
exports.countFieldText = (0, intl_1.defineMessages)({
    count: {
        defaultMessage: "Count",
        id: "Aujn2T",
    },
    enter_number_here: {
        defaultMessage: "Enter number here...",
        id: "zcIUvf",
    },
    sum: {
        defaultMessage: "sum",
        id: "CjC5xr",
    },
    a_linked_record_field_is_required: {
        defaultMessage: "A Linked Record field is required, and there are no Linked Record fields in this application.",
        id: "GfiMR4",
    },
});
exports.linkedRecordFieldText = (0, intl_1.defineMessages)({
    linked_record: {
        defaultMessage: "Linked Record",
        id: "a8IL2p",
    },
    enter_record: {
        defaultMessage: "Enter record",
        id: "CCSZBW",
    },
    reference: {
        defaultMessage: "reference",
        id: "zdR3rQ",
    },
    select_record: {
        defaultMessage: "Select record",
        id: "cMVLzV",
    },
});
exports.assignedToFieldText = (0, intl_1.defineMessages)({
    assigned_to: {
        defaultMessage: "Assigned To",
        id: "FKVdHJ",
    },
    enter_name: {
        defaultMessage: "Enter Name",
        id: "MrqIss",
    },
    user: {
        defaultMessage: `user`,
        id: "sUNhQE",
    },
    member: {
        defaultMessage: "member",
        id: "v8f8hL",
    },
    person: {
        defaultMessage: "person",
        id: "ADU4H2",
    },
    collaborator: {
        defaultMessage: "collaborator",
        id: "qO3+/z",
    },
    current_user: {
        defaultMessage: "Current User",
        id: "3e48nj",
    },
});
exports.subitemsFieldText = (0, intl_1.defineMessages)({
    sub_items: {
        defaultMessage: "Sub-Items",
        id: "21SHP6",
    },
});
exports.timeFieldText = (0, intl_1.defineMessages)({
    time: {
        defaultMessage: "Time",
        id: "ug01Mk",
    },
    enter_time_here: {
        defaultMessage: "Enter time here...",
        id: "L+VbpF",
    },
    hh: {
        defaultMessage: "hh",
        id: "feiWtY",
    },
});
exports.durationFieldText = (0, intl_1.defineMessages)({
    seconds: {
        defaultMessage: "seconds",
        id: "8TQoLR",
    },
    second: {
        defaultMessage: "second",
        id: "k4Hppn",
    },
    minute: {
        defaultMessage: `minute`,
        id: "hqtJko",
    },
    minutes: {
        defaultMessage: "minutes",
        id: "FFKIHh",
    },
    hr: {
        defaultMessage: "hr",
        id: "ZtAZFN",
    },
    hrs: {
        defaultMessage: "hrs",
        id: "In2qYh",
    },
    hour: {
        defaultMessage: "hour",
        id: "fg1Vhq",
    },
    hours: {
        defaultMessage: "hours",
        id: "4MengK",
    },
    day: {
        defaultMessage: "day",
        id: "aVqg31",
    },
    days: {
        defaultMessage: "days",
        id: "Bc20la",
    },
    sec: {
        defaultMessage: `sec`,
        id: "nCxC7R",
    },
    secs: {
        defaultMessage: "secs",
        id: "7SXm1O",
    },
    min: {
        defaultMessage: "min",
        id: "TZr4xU",
    },
    mins: {
        defaultMessage: "mins",
        id: "6G3yvH",
    },
    s: {
        defaultMessage: "s",
        id: "LB7mg3",
    },
    m: {
        defaultMessage: "m",
        id: "8Uquag",
    },
    h: {
        defaultMessage: "h",
        id: "IkG8j8",
    },
    d: {
        defaultMessage: "d",
        id: "SPsQsV",
    },
    duration: {
        defaultMessage: "Duration",
        id: "IuFETn",
    },
    type_minutes_hours_or_days: {
        defaultMessage: "Type minutes, hours or days",
        id: "00VVKx",
    },
    length: {
        defaultMessage: "length",
        id: "JpYIHM",
    },
    dd: {
        defaultMessage: "dd",
        id: "FQmQwB",
    },
    mm: {
        defaultMessage: "mm",
        id: "PlcDcJ",
    },
    yy: {
        defaultMessage: "yy",
        id: "KFhvQc",
    },
});
exports.dateRangeFieldText = (0, intl_1.defineMessages)({
    date_range: {
        defaultMessage: `Date Range`,
        id: "52QtMe",
    },
    add_a_date_range: {
        defaultMessage: "Add a date range.",
        id: "wwX9TZ",
    },
    select_date_range: {
        defaultMessage: "Select Date Range",
        id: "KAX9q+",
    },
});
exports.voteFieldText = (0, intl_1.defineMessages)({
    vote: {
        defaultMessage: `Vote`,
        id: "Y6dihM",
    },
    enter_number_here: {
        defaultMessage: "Enter number here...",
        id: "zcIUvf",
    },
    poll: {
        defaultMessage: "poll",
        id: "6X88wy",
    },
});
exports.availabilityStatusFieldText = (0, intl_1.defineMessages)({
    availability: {
        defaultMessage: `Availability`,
        id: "hOxIeP",
    },
    whats_your_status: {
        defaultMessage: "What’s your status?",
        id: "W6byRA",
    },
});
exports.nesetTextFieldText = (0, intl_1.defineMessages)({
    nested_text: {
        defaultMessage: `Nested Text`,
        id: "lp0+w4",
    },
    enter_value_here: {
        defaultMessage: "Enter value here...",
        id: "93bPRZ",
    },
});
exports.buttonFieldText = (0, intl_1.defineMessages)({
    button: {
        defaultMessage: `Button`,
        id: "KP63fg",
    },
});
exports.createUpdateFieldText = (0, intl_1.defineMessages)({
    fieldLabel_by: {
        defaultMessage: "{fieldLabel} By",
        id: "WBuA6a",
    },
    fieldLabel_on: {
        defaultMessage: "{fieldLabel} On",
        id: "3QCNuk",
    },
    by_member_on: {
        defaultMessage: `"By {member} on" {dateFormat} "at" {timeFormat}`,
        id: "9c44cS",
    },
    unknown: {
        defaultMessage: "unknown",
        id: "uo8NOT",
    },
    by_member_dateString: {
        defaultMessage: `By {member} {dateString}`,
        id: "zW8Hac",
    },
    type_member_name: {
        defaultMessage: "Type Member Name",
        id: "PHNcKF",
    },
    type_number_of_days: {
        defaultMessage: "Type Number of Days",
        id: "MwoS2O",
    },
    select_member: {
        defaultMessage: "Select Member",
        id: "ihRpF8",
    },
    this_is_a_system_field: {
        defaultMessage: "This is a system field and it cannot be duplicated.",
        id: "dwGnRu",
    },
    date_at_time: {
        defaultMessage: `{formattedDate} at {formattedTime}`,
        id: "pm9lwy",
    },
    first_created: {
        defaultMessage: "First Created",
        id: "miK+9d",
    },
    author: {
        defaultMessage: "author",
        id: "/5r8bs",
    },
    by: {
        defaultMessage: "by",
        id: "wTNySU",
    },
    last_updated: {
        defaultMessage: "Last Updated",
        id: "EeRwjE",
    },
    change: {
        defaultMessage: "change",
        id: "zfahHB",
    },
});
exports.timeTrackingLogFieldText = (0, intl_1.defineMessages)({
    time_tracking_log: {
        defaultMessage: `Time Tracking Log`,
        id: "iSWfLk",
    },
    spent: {
        defaultMessage: "spent",
        id: "uA4lrU",
    },
    type_minutes_or_hours: {
        defaultMessage: "Type minutes or hours",
        id: "4mhgGP",
    },
});
exports.socialNetworkFieldText = (0, intl_1.defineMessages)({
    social_network: {
        defaultMessage: "Social Network",
        id: "QlqA09",
    },
    specify_social_networks: {
        defaultMessage: "Specify Social Networks...",
        id: "dBRS5H",
    },
    media: {
        defaultMessage: "media",
        id: "mx2qlA",
    },
    facebook: {
        defaultMessage: "facebook",
        id: "vyo31e",
    },
    instagram: {
        defaultMessage: "instagram",
        id: "R/DVzI",
    },
    twitter: {
        defaultMessage: "twitter",
        id: "la9h/V",
    },
    linkedin: {
        defaultMessage: "linkedin",
        id: "dDsJ/M",
    },
    enter_text_here: {
        defaultMessage: "Enter text here...",
        id: "+lyEkd",
    },
});
exports.colorPickerFieldText = (0, intl_1.defineMessages)({
    enter_a_valid_color: {
        defaultMessage: `Enter a valid color`,
        id: "GLB0dq",
    },
    color_picker: {
        defaultMessage: "Color Picker",
        id: "WH+kpo",
    },
    enter_color_code: {
        defaultMessage: "Enter color code",
        id: "Mu2em7",
    },
});
exports.checklistFieldText = (0, intl_1.defineMessages)({
    checklist: {
        defaultMessage: `Checklist`,
        id: "soCLV+",
    },
    search_by_item_content: {
        defaultMessage: "Search by item content...",
        id: "CIQyuK",
    },
    list: {
        defaultMessage: "list",
        id: "51usok",
    },
    todo: {
        defaultMessage: "todo",
        id: "u4VyEl",
    },
    each_item_is_limited: {
        defaultMessage: "Each item is limited to {checklistItemMaxLength} characters",
        id: "BM53MQ",
    },
    cannot_have_more: {
        defaultMessage: "Can't have more than {checklistMaxNumItems} items",
        id: "xwg1sh",
    },
});
exports.tagsFieldText = (0, intl_1.defineMessages)({
    tag: {
        defaultMessage: `Tag`,
        id: "18HJlm",
    },
    specify_tags: {
        defaultMessage: "Specify tags...",
        id: "bqMXuk",
    },
    hashtag: {
        defaultMessage: "hashtag",
        id: "GpX5WX",
    },
    select_from_list: {
        defaultMessage: "Select from list...",
        id: "zrZNIF",
    },
});
exports.ipAddressFieldText = (0, intl_1.defineMessages)({
    enter_a_valid_ip_address: {
        defaultMessage: "Enter a valid IP address",
        id: "p6bnhK",
    },
    ip_address: {
        defaultMessage: "IP Address",
        id: "uJV0wU",
    },
    enter_ip_address: {
        defaultMessage: "Enter IP address",
        id: "EeF7CH",
    },
    network: {
        defaultMessage: "network",
        id: "OCfOQB",
    },
    internet: {
        defaultMessage: "internet",
        id: "OU7BiP",
    },
});
exports.rollupFieldText = (0, intl_1.defineMessages)({
    rollup: {
        defaultMessage: `Rollup`,
        id: "BDAoYD",
    },
    a_linked_ecord_field_is_required: {
        defaultMessage: "A Linked Record field is required, and there are no Linked Record fields in this application.",
        id: "GfiMR4",
    },
});
exports.formulaFieldText = (0, intl_1.defineMessages)({
    formula: {
        defaultMessage: `Formula`,
        id: "QZEMm+",
    },
    enter_text_here: {
        defaultMessage: "Enter text here...",
        id: "+lyEkd",
    },
    converting_this_formula_to_another_field_type: {
        defaultMessage: "Converting this formula to another field type will remove all formula configuration and store the current value of the formula field as a static value. This action cannot be undone.",
        id: "iP6bj2",
    },
});
exports.lookupFieldText = (0, intl_1.defineMessages)({
    lookup: {
        defaultMessage: `Lookup`,
        id: "VzW9jr",
    },
    mirror: {
        defaultMessage: "mirror",
        id: "I2UbMN",
    },
    a_linked_record_field_is_required: {
        defaultMessage: "A Linked Record field is required, and there are no Linked Record fields in this application.",
        id: "GfiMR4",
    },
});
exports.dependencyFieldText = (0, intl_1.defineMessages)({
    dependency: {
        defaultMessage: `Dependency`,
        id: "vq88eA",
    },
    onlyOneField: {
        defaultMessage: "Each App can have only one Dependency field.",
        id: "uwA1wp",
    },
});
exports.dateFormatDistanceText = (0, intl_1.defineMessages)({
    secondsAgo: {
        defaultMessage: "a few seconds ago",
        id: "aC/wxa",
    },
    daysAgo: {
        defaultMessage: "30 days ago",
        id: "sO5nv6",
    },
    weekAgo: {
        defaultMessage: "{itemCount, plural,=0 {0 weeks ago} one {1 week ago} few {# weeks ago} other {# weeks ago}}",
        id: "OBJpVg",
    },
});
exports.defaultDateDiffNamesText = (0, intl_1.defineMessages)({
    today: {
        defaultMessage: "Today",
        id: "zWgbGg",
    },
    yesterday: {
        defaultMessage: "Yesterday",
        id: "6dIxDP",
    },
});
